export default{
    msg:'',
    editar:{},
    lista:'',
    boletins:'',
    irrf:'',
}